import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { ahcConditionalSponsorIds } from '../../config';

const EAPSection = ({ eapCards }) => {
  const history = useHistory();
  // note: backToCurrent is used to handle back navigation for axis eap program flow
  const sponsorId = useSelector((state) => state.user.sponsorId);
  const isAxisSponsor =
    Number(sponsorId) === ahcConditionalSponsorIds.axisSponsorId;
  const backToCurrent = { inAppBack: isAxisSponsor, from: 'eap' };
  if (!eapCards) return null; // Handle case where eapCards is not provided

  // Determine grid classes based on gridColumn value
  const getGridClasses = (gridColumn, gridlayout) => {
    if (!gridlayout) return ''; // No grid if gridLayout is false

    switch (gridColumn) {
      case 1:
        return 'w-full grid grid-cols-1 gap-2';
      case 2:
        return 'w-full grid grid-cols-2 gap-2';
      case 3:
        return 'w-full grid grid-cols-3 gap-2';
      default:
        return 'w-full grid grid-cols-1 gap-2';
    }
  };

  const gridClasses = getGridClasses(
    eapCards?.gridColumn,
    eapCards?.gridlayout
  );

  const handleCardClick = (card) => {
    switch (card?.cardType || card?.cardKey) {
      case 'mood-journal-program':
      case 'mood-program':
      case 'mood-journal': {
        history.push('/mood-journal/home', backToCurrent);
        break;
      }
      case 'meditation-program': {
        history.push('/health-content/podcasts-home', backToCurrent);
        break;
      }
      case 'yoga-card':
      case 'yoga-program':
      case 'yoga': {
        history.push('/health-content/fitness-home', backToCurrent);
        break;
      }
      case 'professional-program': {
        history.push(
          `/consultation/doctor-select?verticalId=${card.verticalId}`,
          backToCurrent
        );
        break;
      }
      case 'see-all-program': {
        history.push(`/eap/home`, backToCurrent);
        break;
      }
      case 'joye-program': {
        history.push('/joye/intro', backToCurrent);
        break;
      }
      case 'online-consults':
      case 'my-online-consults': {
        history.push('/consultation/online/preview', {
          specialistSearch: false,
          searchType: 'find',
          showSearch: true,
          showVerticals: true,
          ...backToCurrent,
        });
        break;
      }
      case 'offline-consults':
      case 'my-clinic-appointments': {
        history.push('/consultation/preview', {
          specialistSearch: false,
          searchType: 'find',
          ...backToCurrent,
        });
        break;
      }
      case 'dental':
      case 'my-dental-appointments': {
        history.push('/dental/preview', {
          specialistSearch: false,
          searchType: 'find',
          ...backToCurrent,
        });
        break;
      }
      case 'diagnostics':
      case 'lab-tests': {
        history.push('/lab-test', backToCurrent);
        break;
      }
      case 'pharmacy': {
        history.push('/pharmacy', backToCurrent);
        break;
      }
      case 'claims':
      case 'my-claims': {
        history.push('/claims', backToCurrent);
        break;
      }
      case 'reimbursement': {
        history.push('/reimbursement', backToCurrent);
        break;
      }
      case 'benefits': {
        history.push('/home/insure', backToCurrent);
        break;
      }
      case 'rewards': {
        history.push('/home/rewards', backToCurrent);
        break;
      }
      case 'hra':
      case 'hra-card': {
        history.push('/hra', backToCurrent);
        break;
      }
      case 'vaccination':
      case 'cashless-vaccination': {
        history.push('/vaccination/preview', backToCurrent);
        break;
      }
      case 'gym':
      case 'fitness-center': {
        history.push('/gym', backToCurrent);
        break;
      }
      case 'vision':
      case 'eye-care': {
        history.push('/vision', backToCurrent);
        break;
      }
      default: {
        return;
      }
    }
  };

  return (
    <div
      className="w-full p-4 border-b border-txtsecondary-shades4 "
      style={{ borderBottomWidth: '10px' }}
    >
      {eapCards?.showTitle && (
        <div className="text-title-m font-bold mb-16px">{eapCards.title}</div>
      )}
      <div className={gridClasses}>
        {eapCards?.cards?.map((card, index) => (
          <div
            key={index}
            className="bg-white flex flex-col items-center w-full clickable overflow-hidden"
            onClick={() => handleCardClick(card)}
          >
            <div className="px-12px">
              <img src={card.imageUrl} className="flex-shrink-0 mx-auto " />
            </div>
            <h3 className="text-body-s font-medium text-txtsecondary mt-1 text-center whitespace-normal">
              {card.title}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(EAPSection);
